import React, { useMemo } from 'react';
import { User, Shield, Bell, Users, AlertTriangle } from 'lucide-react';
import { NavLink, Outlet } from 'react-router-dom';
import { useOrganization } from '../../contexts/OrganizationContext';

const SettingsLayout: React.FC = () => {
  const { currentOrganization, isLoading } = useOrganization();

  const tabs = useMemo(() => [
    { id: 'profile', path: '/settings', label: 'Profil', icon: User },
    { id: 'security', path: '/settings/security', label: 'Sécurité', icon: Shield },
    { id: 'notifications', path: '/settings/notifications', label: 'Notifications', icon: Bell },
    { id: 'users', path: `/settings/${currentOrganization?.id}/users`, label: 'Utilisateurs', icon: Users, hidden: (!currentOrganization && !isLoading) || currentOrganization?.role == 'member' },
    { id: 'alert-risk-levels', path: `/settings/${currentOrganization?.id}/alert-risk-levels`, label: 'Niveaux de risque', icon: AlertTriangle, hidden: (!currentOrganization && !isLoading) || currentOrganization?.role == 'member' }
  ], [currentOrganization, isLoading]);

  return (
    <div className="p-6">
      {/* Header */}
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900">Paramètres</h2>
        <p className="text-gray-600 mt-1">Gérez vos préférences et configurations</p>
      </div>

      <div className="flex space-x-6">
        {/* Sidebar */}
        <div className="w-64 space-y-1">
          {tabs.map((tab) => {
            if(tab.hidden) {
              return null;
            }

            const Icon = tab.icon;
            return (
              <NavLink
                key={tab.id}
                to={tab.path}
                end={tab.id === 'profile'}
                className={({ isActive }) =>
                  `w-full flex items-center space-x-3 px-4 py-3 text-left rounded-lg transition-colors ${
                    isActive
                      ? 'bg-blue-50 text-blue-700 border border-blue-200'
                      : 'text-gray-600 hover:bg-gray-50'
                  }`
                }
              >
                <Icon className="h-5 w-5" />
                <span className="font-medium">{tab.label}</span>
              </NavLink>
            );
          })}
        </div>

        {/* Content */}
        <div className="flex-1 max-w-2xl">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default SettingsLayout;

